import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import './AddButton.css';

interface AddButtonProps {
  onClick: () => void;
  icon?: IconDefinition;
  ariaLabel?: string;
}

const AddButton: React.FC<AddButtonProps> = ({ 
  onClick, 
  icon = faPlus, 
  ariaLabel = 'Add' 
}) => {
  return (
    <button 
      className="add-button" 
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <FontAwesomeIcon icon={icon} />
    </button>
  );
};

export default AddButton;

